(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["commerce-updates"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ChateauCommerce) return;
    let mutations = Promise.resolve();
    let movementRevision = 0;
    let viewLocks = 0;
    let previousAnchors;
    const holdAnchoring = () => {
      if (viewLocks === 0) {
        previousAnchors = [document.documentElement.style.overflowAnchor, document.body.style.overflowAnchor];
        document.documentElement.style.overflowAnchor = 'none';
        document.body.style.overflowAnchor = 'none';
      }
      viewLocks += 1;
      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        viewLocks -= 1;
        if (viewLocks === 0) {
          document.documentElement.style.overflowAnchor = previousAnchors[0];
          document.body.style.overflowAnchor = previousAnchors[1];
        }
      };
      setTimeout(release, 300);
      return release;
    };
    const movementKeys = new Set(['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ']);
    window.addEventListener('wheel', () => { movementRevision += 1; }, { passive: true });
    window.addEventListener('touchmove', () => { movementRevision += 1; }, { passive: true });
    window.addEventListener('keydown', (event) => {
      if (movementKeys.has(event.key)) movementRevision += 1;
    });
    const rootURL = () => {
      const value = document.querySelector('[data-commerce-root]')?.dataset.commerceRoot || window.Shopify?.routes?.root || '/';
      return `${value.replace(/\/$/, '')}/`;
    };
    const request = async (destination, { method = 'GET', body, signal } = {}) => {
      const url = new URL(destination, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid commerce destination');
      const controller = new AbortController();
      const abort = () => controller.abort();
      if (signal?.aborted) controller.abort();
      signal?.addEventListener('abort', abort, { once: true });
      const timeout = setTimeout(abort, 15000);
      const headers = { Accept: 'application/json' };
      if (body !== undefined && !(body instanceof FormData) && !(body instanceof URLSearchParams) && typeof body !== 'string') {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(body);
      }
      let response;
      let data;
      try {
        response = await fetch(url, { method, body, headers, signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
        data = await response.json();
      } catch (cause) {
        if (signal?.aborted) throw cause;
        const error = new Error('Commerce response could not be confirmed', { cause });
        error.status = response?.status || 0;
        error.uncertain = method.toUpperCase() !== 'GET';
        throw error;
      } finally {
        clearTimeout(timeout);
        signal?.removeEventListener('abort', abort);
      }
      if (!response.ok) {
        const message = typeof data?.description === 'string' ? data.description : typeof data?.message === 'string' ? data.message : 'Commerce request failed';
        const error = new Error(message);
        error.status = response.status;
        error.data = data;
        error.uncertain = response.status >= 500 && method.toUpperCase() !== 'GET';
        throw error;
      }
      return data;
    };
    const captureView = (scope = document) => {
      const active = document.activeElement;
      const inside = Boolean(active && scope.contains(active));
      const view = { x: window.scrollX, y: window.scrollY, movementRevision, active, inside, releaseAnchoring: holdAnchoring() };
      if (inside) {
        view.id = active.id;
        view.name = active.getAttribute('name');
        try {
          view.selectionStart = active.selectionStart;
          view.selectionEnd = active.selectionEnd;
        } catch {}
      }
      return view;
    };
    const restoreView = (view, scope = document, { focusSelector } = {}) => {
      if (!view) return;
      if (movementRevision !== view.movementRevision) {
        view.releaseAnchoring?.();
        return;
      }
      const current = document.activeElement;
      const canRestoreFocus = view.inside && (current === document.body || current === view.active || scope.contains(current));
      if (canRestoreFocus) {
        let target;
        if (focusSelector) target = scope.querySelector(focusSelector);
        if (!target && view.id) target = scope.querySelector(`#${CSS.escape(view.id)}`);
        if (!target && view.name) target = scope.querySelector(`[name="${CSS.escape(view.name)}"]`);
        if (target && !target.disabled) {
          target.focus({ preventScroll: true });
          if (typeof target.setSelectionRange === 'function' && view.selectionStart !== null && view.selectionStart !== undefined) {
            try { target.setSelectionRange(view.selectionStart, view.selectionEnd); } catch {}
          }
        }
      }
      window.scrollTo({ left: view.x, top: view.y, behavior: 'instant' });
      requestAnimationFrame(() => {
        if (movementRevision === view.movementRevision) window.scrollTo({ left: view.x, top: view.y, behavior: 'instant' });
        requestAnimationFrame(() => view.releaseAnchoring?.());
      });
    };
    window.ChateauCommerce = {
      request,
      captureView,
      restoreView,
      cartEndpoint(action = '') { return `${rootURL()}cart${action ? `/${action}` : ''}.js`; },
      enqueue(task) {
        const result = mutations.then(task);
        mutations = result.catch(() => {});
        return result;
      },
      fetchSections(contextURL, ids, { signal } = {}) {
        const url = new URL(contextURL, location.origin);
        url.hash = '';
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', [...new Set(ids)].slice(0, 5).join(','));
        return request(url, { signal });
      },
      publishCart(cart) {
        if (Number.isInteger(cart?.item_count) && cart.item_count >= 0) {
          document.querySelectorAll('[data-cart-count]').forEach((counter) => { counter.textContent = String(cart.item_count); });
          document.querySelectorAll('[data-cart-link]').forEach((link) => {
            link.setAttribute('aria-label', `${link.dataset.cartLabel} (${cart.item_count})`);
          });
        }
        document.dispatchEvent(new CustomEvent('chateau:cart:updated', { detail: { cart } }));
      },
    };
    document.dispatchEvent(new Event('chateau:commerce:ready'));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-return"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.language-switcher--inline, .language-switcher__options, .localization-form')) return;
    const destination = form.elements.namedItem('return_to');
    if (destination instanceof HTMLInputElement) {
      destination.value = location.pathname + location.search + location.hash;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const completed = new WeakSet();
    const pending = new Set();
    const active = new Map();
    const selector =
      '.estate-panel:not(.estate-panel--detail), .page-chapters__link, .editorial__copy, .editorial__item, .editorial__image, .wine-card, .experience-card, .journal-card, .collection-card, .content-stack > h2, .content-stack > .eyebrow, .section-space .prose, .product-copy__title, .product-description, .wine-details, .article-photo, .page-intro, .article-back';
    let observer;
    const enabled = () =>
      document.body.dataset.themeMotion !== 'false' &&
      document.body.dataset.themeEditor !== 'true' &&
      !preference.matches;
    const complete = (element) => {
      observer?.unobserve(element);
      pending.delete(element);
      completed.add(element);
      element.dataset.reveal = 'done';
    };
    const cancel = () => {
      observer?.disconnect();
      observer = undefined;
      for (const element of pending) delete element.dataset.reveal;
      pending.clear();
      for (const [element, animations] of active) {
        complete(element);
        animations.forEach((animation) => animation.cancel());
      }
      active.clear();
    };
    const initialize = (root = document) => {
      if (!enabled() || !('IntersectionObserver' in window)) return;
      observer ??= new IntersectionObserver(
        (entries) => {
          const groups = new Map();
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const element = entry.target;
            if (!enabled() || typeof element.animate !== 'function' || element.contains(document.activeElement)) {
              complete(element);
              continue;
            }
            observer.unobserve(element);
            pending.delete(element);
            completed.add(element);
            element.dataset.reveal = 'active';
            const compact = matchMedia('(max-width: 749px)').matches;
            const group = element.parentElement;
            const order = groups.get(group) || 0;
            groups.set(group, order + 1);
            const delay = Math.min(order, 3) * (compact ? 60 : 90);
            const start = getComputedStyle(element).translate;
            const animation = element.animate(
              [
                { opacity: 0, translate: start },
                { opacity: 1, translate: '0 0' },
              ],
              { duration: compact ? 700 : 900, delay, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' },
            );
            const animations = [animation];
            active.set(element, animations);
            Promise.all(animations.map((effect) => effect.finished)).then(
              () => {
                complete(element);
                active.delete(element);
                animation.cancel();
              },
              () => {
                complete(element);
                active.delete(element);
              },
            );
          }
        },
        { threshold: 0.08, rootMargin: '0px 0px -36px 0px' },
      );
      const candidates = [...root.querySelectorAll(selector)].filter((element) => {
        if (!element.closest('#MainContent')) return false;
        if (getComputedStyle(element).display === 'contents') return false;
        let parent = element.parentElement.closest(selector);
        while (parent) {
          if (getComputedStyle(parent).display !== 'contents') return false;
          parent = parent.parentElement.closest(selector);
        }
        if (element.querySelector('form, input, select, textarea, iframe')) return false;
        return !completed.has(element) && !pending.has(element);
      });
      for (const element of candidates) {
        if (element.getBoundingClientRect().top < innerHeight) {
          completed.add(element);
          continue;
        }
        element.dataset.reveal = 'pending';
        pending.add(element);
        observer.observe(element);
      }
    };
    document.addEventListener('focusin', (event) => {
      const element = event.target instanceof Element ? event.target.closest('[data-reveal]') : null;
      if (!element) return;
      complete(element);
      active.get(element)?.forEach((animation) => animation.cancel());
      active.delete(element);
    });
    preference.addEventListener('change', () => {
      cancel();
      initialize();
    });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      for (const element of [...pending]) {
        if (event.target.contains(element)) {
          observer?.unobserve(element);
          pending.delete(element);
        }
      }
      for (const [element, animations] of active) {
        if (event.target.contains(element)) {
          complete(element);
          animations.forEach((animation) => animation.cancel());
          active.delete(element);
        }
      }
    });
    window.addEventListener('pageshow', () => requestAnimationFrame(() => initialize()));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purchase-conditions"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeNativeVolumePrices = (scope = document) => {
      scope.querySelectorAll('[data-native-volume-prices]').forEach((pricing) => {
        if (pricing.dataset.volumeReady) return;
        const form = document.getElementById(pricing.dataset.formId);
        const quantity = form?.querySelector('input[name="quantity"]');
        const rows = [...pricing.querySelectorAll('[data-native-volume-tier]')];
        if (!quantity || !rows.length) return;
        const cartQuantity = Number(pricing.dataset.volumeCartQuantity) || 0;
        const minimum = Number(quantity.min) || 1;
        const increment = Number(quantity.step) || 1;
        const maximum = quantity.hasAttribute('max') ? Number(quantity.max) : Infinity;
        const summary = pricing.querySelector('[data-volume-summary]');
        const error = pricing.querySelector('[data-volume-error]');
        const announcement = pricing.querySelector('[data-volume-announcement]');
        const priceDisplays = [...document.querySelectorAll('[data-volume-price-form]')]
          .filter((display) => display.dataset.volumePriceForm === pricing.dataset.formId);
        let currencyFormat;
        try {
          currencyFormat = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
            style: 'currency', currency: pricing.dataset.currency,
          });
        } catch {
          return;
        }
        const formatPrice = (price) => currencyFormat.format(price / 100);
        const update = (announce = false, preserveView = false) => {
          const commerce = window.ChateauCommerce;
          const view = preserveView ? commerce?.captureView(form) : null;
          try {
            const selectedQuantity = quantity.valueAsNumber;
            const valid = !quantity.disabled && Number.isInteger(selectedQuantity) && quantity.validity.valid;
            error.hidden = valid || quantity.disabled;
            summary.hidden = !valid;
            quantity.setAttribute('aria-invalid', String(!valid && !quantity.disabled));
            if (!valid) {
              rows.forEach((row) => {
                row.classList.remove('is-selected');
                row.querySelector('button').setAttribute('aria-pressed', 'false');
              });
              if (announce) announcement.textContent = quantity.disabled ? '' : error.textContent;
              return;
            }
            const combinedQuantity = cartQuantity + selectedQuantity;
            let selectedRow = rows[0];
            rows.forEach((row) => {
              if (combinedQuantity >= Number(row.dataset.threshold)) selectedRow = row;
            });
            const unitPrice = Number(selectedRow.dataset.price);
            const unitLabel = selectedRow.querySelector('[data-tier-price-label]').textContent.trim();
            const totalLabel = formatPrice(unitPrice * selectedQuantity);
            rows.forEach((row) => {
              const selected = row === selectedRow;
              row.classList.toggle('is-selected', selected);
              row.querySelector('button').setAttribute('aria-pressed', String(selected));
            });
            pricing.querySelector('[data-volume-unit-price]').textContent = unitLabel;
            pricing.querySelector('[data-volume-total-price]').textContent = totalLabel;
            pricing.querySelector('[data-volume-added-quantity]').textContent = `(${selectedQuantity})`;
            pricing.querySelector('[data-volume-combined-quantity]').textContent = pricing
              .querySelector('[data-volume-cart-template]').textContent.replace('[quantity]', combinedQuantity);
            priceDisplays.forEach((display) => { display.textContent = unitLabel; });
            if (announce) {
              announcement.textContent = pricing.querySelector('[data-volume-announcement-template]').textContent
                .replace('[quantity]', selectedQuantity).replace('[unit_price]', unitLabel).replace('[total]', totalLabel);
            }
          } finally {
            if (view) commerce.restoreView(view, form);
          }
        };
        rows.forEach((row) => {
          const button = row.querySelector('button');
          const remaining = Number(row.dataset.threshold) - cartQuantity;
          const amount = Math.max(minimum, minimum + Math.ceil((remaining - minimum) / increment) * increment);
          button.hidden = false;
          button.disabled = quantity.disabled || amount > maximum;
          button.addEventListener('click', () => {
            quantity.value = String(amount);
            quantity.dispatchEvent(new Event('input', { bubbles: true }));
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        pricing.dataset.volumeReady = 'true';
        quantity.addEventListener('input', () => update(false, true));
        quantity.addEventListener('change', () => update(true, true));
        update();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeNativeVolumePrices(), { once: true });
    } else {
      initializeNativeVolumePrices();
    }
    document.addEventListener('shopify:section:load', (event) => initializeNativeVolumePrices(event.target));
    document.addEventListener('chateau:commerce:updated', (event) => initializeNativeVolumePrices(event.detail?.root || document));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stay-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const dayString = (date) =>
      `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    const parseDay = (value) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
      const date = new Date(`${value}T12:00:00`);
      return Number.isFinite(date.getTime()) && dayString(date) === value ? date : null;
    };
    const initialize = (root) => {
      root.querySelectorAll('[data-stay-search]').forEach((form) => {
        if (form.dataset.initialized) return;
        form.dataset.initialized = 'true';
        const arrival = form.elements.arrival;
        const departure = form.elements.departure;
        const guests = form.elements.guests;
        const error = form.querySelector('[role="alert"]');
        const today = () => dayString(new Date());
        const datesMinimum = () => {
          const minimum = today();
          if (arrival.min !== minimum) arrival.min = minimum;
          const day = parseDay(arrival.value);
          if (day) day.setDate(day.getDate() + 1);
          const departureMinimum = day ? dayString(day) : minimum;
          if (departure.min !== departureMinimum) departure.min = departureMinimum;
        };
        form.querySelectorAll('[data-date-picker]').forEach((button) => {
          const field = form.elements[button.dataset.datePicker];
          if (typeof field.showPicker !== 'function' || window.self !== window.top) return;
          const wrapper = button.closest('.stay-search__date');
          wrapper.classList.add('stay-search__date--enhanced');
          button.hidden = false;
          button.addEventListener('click', () => {
            datesMinimum();
            field.focus();
            try {
              field.showPicker();
            } catch {
              wrapper.classList.remove('stay-search__date--enhanced');
              button.hidden = true;
            }
          });
        });
        const validate = (report = false) => {
          datesMinimum();
          let invalid = null;
          let message = '';
          [arrival, departure, guests].forEach((field) => {
            field.setCustomValidity('');
            field.removeAttribute('aria-invalid');
          });
          if (!arrival.value || !departure.value || !guests.value) {
            invalid = [arrival, departure, guests].find((field) => !field.value);
            message = form.dataset.errorRequired;
          } else if (!parseDay(arrival.value) || arrival.value < today()) {
            invalid = arrival;
            message = form.dataset.errorArrival;
          } else if (!parseDay(departure.value) || departure.value <= arrival.value) {
            invalid = departure;
            message = form.dataset.errorDeparture;
          } else if (!Number.isSafeInteger(Number(guests.value)) || Number(guests.value) < 1) {
            invalid = guests;
            message = form.dataset.errorGuests;
          }
          if (invalid) {
            invalid.setCustomValidity(message);
            if (report) invalid.setAttribute('aria-invalid', 'true');
          }
          error.textContent = report ? message : '';
          error.hidden = !error.textContent;
          return !invalid;
        };
        form.addEventListener('input', () => validate(!error.hidden));
        form.addEventListener('change', () => validate(!error.hidden));
        form.addEventListener('invalid', () => validate(true), true);
        form.addEventListener('submit', (event) => {
          if (validate(true)) return;
          event.preventDefault();
          form.querySelector('[aria-invalid="true"]')?.focus();
        });
        if (form.closest('[data-stay-results]')) {
          const params = new URLSearchParams(window.location.search);
          const hasCriteria = ['arrival', 'departure', 'guests'].some((key) => params.has(key));
          if (hasCriteria) {
            arrival.value = params.get('arrival') || '';
            departure.value = params.get('departure') || '';
            guests.value = params.get('guests') || '';
            const result = form.closest('[data-stay-results]');
            if (validate(true)) {
              const criteria = { arrival: arrival.value, departure: departure.value, guests: Number(guests.value) };
              result.dataset.stayArrival = criteria.arrival;
              result.dataset.stayDeparture = criteria.departure;
              result.dataset.stayGuests = String(criteria.guests);
              result.dataset.stayState = 'awaiting-provider';
              result.dispatchEvent(new CustomEvent('piegue:stay-search', { bubbles: true, detail: criteria }));
            } else {
              result.dataset.stayState = 'invalid';
            }
          }
        }
        datesMinimum();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
